import { walkWidgetConfigTree } from '../../walkWidgetConfigTree';
/**
 * Mutates widget config based on rules.
 * @param {WidgetConfigBase} config - Widget configuration.
 * @param {Widget<any, any>[]} widgets - A list of available widgets used during the config traversal.
 * @param {*} [data] - Optional form data used when applying rules.
 * @param {Record<string, any>} [formParams] - Optional parameters related to the form context.
 * @param {Rule[]} [rules] - A list of rules to be applied to the widget configuration.
 *
 * @returns {void}
 */
export function applyRules(config, widgets, data, formParams, rules) {
    if (rules && rules.length > 0) {
        const ruleMap = {};
        for (const rule of rules) {
            ruleMap[rule.type] = rule;
        }
        walkWidgetConfigTree(config, widgets, (config) => {
            if (config.rules) {
                for (const ruleType of config.rules) {
                    const rule = ruleMap[ruleType];
                    if (rule) {
                        try {
                            rule.applyRule(config, data, formParams);
                        }
                        catch (error) {
                            console.error('Error in event ' + ruleType + ' applyRule function', error);
                        }
                    }
                    else {
                        console.warn('Rule ' + ruleType + ' is not defined');
                    }
                }
            }
        });
    }
}
